import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText, { useTranslation } from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function UserRequest() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setSPartners] = useState([])
    const [users, setUsers] = useState([])

    const { showSnackbar } = useSnackbar();

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')
    const subject: string | null = params.get('subject')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const priorities: any = {
        'low': useTranslation('Low'),
        'medium': useTranslation('Medium'),
        'high': useTranslation('High'),
    }

    const statuses: any = {
        'not completed': useTranslation('Not completed'),
        'completed': useTranslation('Completed'),
        'planned': useTranslation('Accepted, system improvement in the next version of the robot'),
        'closed': useTranslation('Closed'),
    }

    //Switch header title


    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Request` : 'New Request'))
    }, [dispatch]);

    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get did
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/usermessages/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setRequestData(response.data)
            }

            console.log(response.data);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create did
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/usermessages`, {
                ...requestData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit did
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/usermessages/${id}`, {
                ...requestData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [requestData, setRequestData] = useState<any>(type === 'edit' ? [] :
        {
            "subject": subject || "",
            "body": "",
            "priority": "low"
        }
    )


    //Get conversationtemplate for Select field
    async function getUsers(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/user`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })

            if (response.data !== null) {
                setUsers(response.data.filter((el: any) => el.accesslevel == 3 || el.accesslevel == 5))
            }
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    //On load if URL params contains type=edit - get data
    useEffect(() => {
        type === 'edit' && fetchData()
        getUsers()
        console.log(requestData);
        console.log(requestData.updatedbycg);

    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField sx={{ width: "100%" }} onChange={(e) => setRequestData({ ...requestData, subject: e.target.value !== '' ? e.target.value : null })} value={requestData.subject || ''} variant="outlined" size="small" label={<TranslatedText text={'Topic'} />} />
                    <TextField sx={{ width: "100%", '& textarea': { resize: 'vertical' }, mb: 2 }}
                        label={<TranslatedText text={'Message'} />}
                        onChange={(e) => setRequestData({ ...requestData, body: e.target.value !== '' ? e.target.value : null })}
                        value={requestData.body || ''}
                        multiline
                        rows={25}
                        fullWidth
                        variant="outlined" />
                    <Box sx={{ flexWrap: 'wrap', display: 'flex', gap: 3 }}>
                        {type === 'edit' &&
                            <FormControl>
                                <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Status'} /></InputLabel>
                                <Select renderValue={(selected) => {
                                    return statuses[selected]
                                }} sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setRequestData({ ...requestData, status: e.target.value !== "" ? e.target.value : null })} value={requestData.status || ''} variant="outlined" size="small" label={<TranslatedText text={'Status'} />} >
                                    <MenuItem value={'not completed'}><TranslatedText text={'Not completed'} /></MenuItem>
                                    <MenuItem value={'completed'}><TranslatedText text={'Completed'} /></MenuItem>
                                    <MenuItem value={'planned'}><TranslatedText text={'Accepted, system improvement in the next version of the robot'} /></MenuItem>
                                    <MenuItem value={'closed'}><TranslatedText text={'Сlosed'} /></MenuItem>
                                </Select>
                            </FormControl>}
                        <FormControl>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Priority'} /></InputLabel>
                            <Select renderValue={(selected) => {
                                return priorities[selected]
                            }} sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setRequestData({ ...requestData, priority: e.target.value !== "" ? e.target.value : null })} value={requestData.priority || ''} variant="outlined" size="small" label={<TranslatedText text={'Priority'} />} >
                                <MenuItem value={'low'}><TranslatedText text={'Low'} /></MenuItem>
                                <MenuItem value={'medium'}><TranslatedText text={'Medium'} /></MenuItem>
                                <MenuItem value={'high'}><TranslatedText text={'High'} /></MenuItem>
                            </Select>
                        </FormControl>
                        {/* {accesslevel == 5 && <FormControl>
                            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'User'} /></InputLabel>
                            <Select sx={{ width: 500 }} labelId="simple-select-label" onChange={(e) => setRequestData({ ...requestData, user: e.target.value !== '' ? e.target.value : null })} value={requestData.user || ''} variant="outlined" size="small" label={<TranslatedText text={'User'} />} >
                                {
                                    users.map((el: any) => {
                                        return (
                                            <MenuItem key={el.id} value={el.id}>{`${el.partnerbankcode !== null ? `${el.partnerbankcode}-` : ''}${el.lastname} ${el.firstname}`}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>} */}
                    </Box>
                </Box>
                {requestData.length != 0 && <Button
                    onClick={() => type === "edit" ? putData(requestData) : postData(requestData)}
                    variant="contained"
                    sx={{ width: "100%" }}
                >
                    {type === "edit" ? (
                        accesslevel == 5
                            ? (requestData.updatedbycg != null
                                ? <TranslatedText text={'Edit'} />
                                : <TranslatedText text={'Reply'} />)
                            : (requestData.updatedbycg == null
                                ? <TranslatedText text={'Edit'} />
                                : <TranslatedText text={'Reply'} />)
                    ) : (
                        <TranslatedText text={'Send'} />
                    )}
                </Button>}
            </Box>
            {snackbarType === 'success' && <Navigate to='/userrequests' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}